export default {
  /**
   * @type {string} *
   * @description 系统标题
   */
  SystemTitle: "梁明振・全栈开发 | LIANG・MINGZHEN DEVELOPMENT",

  /**
   * @type {string} *
   * @description 版权公司
   */
  copyrightCompany: "梁明振・全栈开发版权",

};
